// extracted by mini-css-extract-plugin
export default {"ordersTable":"OrdersList_ordersTable__C8NQ8","ordersListItem":"OrdersList_ordersListItem__UZzp8"};